export class Account {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.profile = params.profile ? params.profile_id : null
    this.profileId = params.profile_id ? params.profile_id : null
    this.active = params.active ? params.active : false
    this.editable = params.editable ? params.editable : false
    this.attributes = params.attributes ? params.attributes : null
  }
}
